import { paletteTheme } from "@configs/theme/custom/palette";

export const tagTheme = {
  defaultBg: paletteTheme.colorFillSecondary,
  defaultColor: paletteTheme.colorIcon,
  fontFamily: "RedHatDisplayMedium",
};
